import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "../config/api";
import { removeUser } from "./auth";

// Create axios instance with base URL and credentials
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Enable cookies (including HTTP-only cookies)
});

// Note: Token is now stored in HTTP-only cookie, so we don't need to add Authorization header
// Backend will automatically read token from cookie

// Add response interceptor to handle 401 errors (unauthorized)
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect to login if we're already on login page (login attempts can return 401)
      const isLoginRequest = error.config?.url?.includes("/auth/login");
      const isLogoutRequest = error.config?.url?.includes("/auth/logout");

      if (!isLoginRequest && !isLogoutRequest) {
        // Token expired or invalid, logout user
        removeUser();
        // Only redirect if not already on login page
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
